import { ThemeEvents, CartUpdatedEvent } from '@theme/events';

// Ajout instantané depuis une carte produit de collection (variante unique).
// Délégué au document. Ouvre le cart drawer après ajout.
document.addEventListener('click', async (event) => {
  const btn = event.target.closest('.coll-add');
  if (!btn) return;

  event.preventDefault();
  event.stopPropagation();

  const variantId = btn.dataset.variantId;
  if (!variantId || btn.classList.contains('is-loading')) return;

  const drawer = document.querySelector('cart-drawer');
  const sectionId = drawer?.dataset.sectionId;

  const original = btn.innerHTML;
  btn.classList.add('is-loading');

  try {
    const addUrl = (window.Theme && Theme.routes && Theme.routes.cart_add_url) || '/cart/add.js';
    const body = { items: [{ id: variantId, quantity: 1 }], sections_url: window.location.pathname };
    if (sectionId) body.sections = sectionId;

    const response = await fetch(addUrl, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body),
    });
    const data = await response.json();

    if (data.status) {
      btn.classList.remove('is-loading');
      btn.innerHTML = original;
      return;
    }

    let itemCount;
    try {
      itemCount = (await fetch('/cart.js', { headers: { Accept: 'application/json' } }).then((r) => r.json())).item_count;
    } catch (e) {
      itemCount = undefined;
    }

    document.dispatchEvent(
      new CartUpdatedEvent({}, { source: 'collection-card', sections: data.sections, itemCount }),
    );
    document.dispatchEvent(new Event(ThemeEvents.cartOpen));

    btn.innerHTML = '✓ Ajouté';
    setTimeout(() => {
      btn.classList.remove('is-loading');
      btn.innerHTML = original;
    }, 1400);
  } catch (e) {
    console.error(e);
    btn.classList.remove('is-loading');
    btn.innerHTML = original;
  }
});
